import { LookupSidebarCompany } from '~/components/LookupSidebar/Company';

const CompanyLookup = ({ domain }: { domain: string }) => {
  return <LookupSidebarCompany domain={domain} />;
};

export default CompanyLookup;
